'use strict';
/*!
 * Year picker.
 *
 * @package tokai-univ
 * @deps jquery
 */

const $ = jQuery;

// Add year select handler.
$( '#news-archive-select' ).change( function () {
	if ( $( this ).val() !== '' ) {
		window.location.href = $( this ).val();
	}
} );
